<template>
  <div>
    <personal-data :user="thisuser" :user-role="user"></personal-data>
    <!-- <md-button
            class="waves-effect waves-light purple darken-4"
            v-if="thisuser.username === user.username"
            v-link="{name: 'edituser'}"
    >
      <md-icon right>edit</md-icon>
      {{ $t("account.personalData.edit") }}
    </md-button>-->

  </div>
</template>
<script>
import PersonalData from './personalData'
import { getUser } from '../../../vuex/getters'
import UserService from '../../../services/user'
// import Storage from '../../../services/lstorage'

export default {
  vuex: {
    getters: {
      user: getUser
    }
  },
  data () {
    return {
      thisuser: UserService.user
    }
  },
  components: {
    PersonalData
  },
  events: {
  }
}
</script>



// WEBPACK FOOTER //
// data.vue?1bcfad58